import { graphql } from "msw";
import {
    generateSingleComment,
    mockCommentsData,
} from "./mockCommentsData";

let mockComments = mockCommentsData([
    { minReplies: 0, maxReplies: 4, archived: false }, 
    { minReplies: 0, maxReplies: 10, archived: false }, 
    { minReplies: 0, maxReplies: 2, archived: true, },
    { minReplies: 0, maxReplies: 0, archived: true, },
    { minReplies: 0, maxReplies: 1, archived: true, },
]);

const flatMockComments = () => [ ...mockComments, ...mockComments.flatMap(({ replies }) => replies), ];

export const handlers = [
    graphql.query("LoadComment", (req, res, ctx) => {
        const { payload: commentId } = req.variables;
        const comment = flatMockComments().find(({ id }) => id === commentId);
        return res(ctx.data(comment));
    }),
    graphql.query("LoadAllComments", (req, res, ctx) =>
        res(
            ctx.data(
                mockComments.map(({ id }) => ({
                    ...generateSingleComment(),
                    id,
                }))
            )
        )
    ),
    graphql.mutation("CreateComment", (req, res, ctx) => {
        const { payload: comment } = req.variables;
        const newComment = {
            ...generateSingleComment(),
            content: comment,
            archived: false,
            replies: [],
        };
        mockComments = [ ...mockComments, newComment ];
        return res(ctx.data(newComment));
    }),
    graphql.mutation("ReplyToComment", (req, res, ctx) => {
        const {
            payload: { replyTo, content },
        } = req.variables;
        const newComment = {
            ...generateSingleComment(),
            content,
            archived: false,
            replies: [],
        };
        mockComments = mockComments.map(comment =>
            comment.id === replyTo
                ? { ...comment, replies: [ ...comment.replies, newComment ]}
                : comment
        );
        return res(ctx.data(newComment));
    }),
    graphql.mutation("UpdateComment", (req, res, ctx) => {
        const {
            payload: { commentId, ...restUpdate },
        } = req.variables;
        const updatedComment = {
            ...flatMockComments().find(({ id }) => id === commentId),
            ...restUpdate,
        };
        mockComments = [ ...mockComments, updatedComment ];
        return res(ctx.data(updatedComment));
    }),
    graphql.mutation("DeleteComment", (req, res, ctx) => {
        const { payload: commentId } = req.variables;
        mockComments = mockComments.filter(({ id }) => id !== commentId);
        return res(ctx.data(mockComments));
    })
];
